export * from './components.service';
import { ComponentsService } from './components.service';
export * from './default.service';
import { DefaultService } from './default.service';
export * from './receivers.service';
import { ReceiversService } from './receivers.service';
export * from './senders.service';
import { SendersService } from './senders.service';
export const APIS = [ComponentsService, DefaultService, ReceiversService, SendersService];
